import { useState, useRef } from 'react';
import Container from '../Container';
import Card from '../Card';
import FileUploader from './FileUploader';
import FileList from './FileList';

const FileUploadComponent = ({ patient_id }) => {
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);

  const acceptedTypes = {
    'image/jpeg': '.jpg',
    'image/png': '.png',
    'image/gif': '.gif',
    'image/webp': '.webp',
    'application/pdf': '.pdf'
  };

  const handleFiles = (newFiles) => {
    const validFiles = newFiles.filter(file => 
      Object.keys(acceptedTypes).includes(file.type)
    );
    
    const processedFiles = validFiles.map(file => ({
      id: Math.random().toString(36).substr(2, 9),
      file,
      name: file.name,
      size: file.size,
      type: file.type,
      preview: file.type.startsWith('image/') ? URL.createObjectURL(file) : null,
      uploaded: false
    }));

    setFiles(prev => [...prev, ...processedFiles]);
    
    // Simulate upload process
    processedFiles.forEach(fileObj => {
      setTimeout(() => {
        setFiles(prev => prev.map(f => 
          f.id === fileObj.id ? { ...f, uploaded: true } : f
        ));
      }, Math.random() * 2000 + 1000);
    });
  };

  const removeFile = (id) => {
    setFiles(prev => prev.filter(f => f.id !== id));
  };

  return (
    <Container>
      <Card className="bg-gray-50">
        <FileUploader fileInputRef={fileInputRef} handleFiles={handleFiles} />
        {files.length > 0 && (
          <FileList files={files} setFiles={setFiles} removeFile={removeFile} />
        )}
      </Card>
    </Container>
  );
};

export default FileUploadComponent;